import React, {useState} from "react";
import styled from "styled-components";
import { primaryBlack, inter, white, Button } from "../../../Theme";
import Api from "../../../util/Api";
import AppStorage, {StorageKey} from "../../../util/AppStorage";
import showBasicPopup from "../../../popups/showBasicPopup";

function FeedbackForm() {

    const [message, setMessage] = useState('');

    return (
        <FeedbackFormRoot>
            <Title>Heb jij feedback voor ons?</Title>
            <Text>
                We proberen de EF-planagenda steeds een beetje beter te maken.
                Heb je een idee of ondervind je problemen? Dan ontvangen we jouw feedback heel graag!
                Wij proberen binnen een werkdag te reageren.
                <br/>
                <br/>
                Groeten van het EF-planagenda team.
            </Text>

            <Label>Bericht</Label>
            <Textarea value={message} onChange={(e) => {
                setMessage(e.target.value)
            }}/>
            <StyledButton onClick={() => sendFeedback()}>Versturen</StyledButton>
        </FeedbackFormRoot>
    )

    function sendFeedback() {
        const data = {
            senderId: AppStorage.get(StorageKey.USER_ID),
            message: message
        }
        Api.put('feedback', data, onSuccess, null, onFailure, onFailure);
    }

    function onSuccess() {
        setMessage("")
        showBasicPopup("Bedankt voor de feedback!", null, "Ok")
    }

    function onFailure() {
        showBasicPopup("Mislukt!", "Het versturen van je feedback is helaas niet gelukt, probeer het nog een keer!", "Ok")
    }
}

export default FeedbackForm;

export const FeedbackFormRoot = styled.div`
    background: ${white};
    width: 100%;
    padding: 20px 15px;
`;

export const Title = styled.div`
    font-family: ${inter};
    font-size: 16px;
    font-weight: 700;
    color: ${primaryBlack};
    margin-bottom: 5px;
`;

export const Text = styled.div`
    font-family: ${inter};
    font-size: 16px;
    font-weight: 400;
    color: ${primaryBlack};
    margin-bottom: 25px;
`;

export const Label = styled.div`
    font-family: ${inter};
    font-size: 14px;
    font-weight: 400;
    color: ${primaryBlack};
    opacity: 0.6;
`;

export const Textarea = styled.textarea`
    font-family: ${inter};
    font-size: 14px;
    font-weight: 400;
    color: ${primaryBlack};
    width: 100%;
    height: 123px;
    padding: 5px 10px;
    resize: none;
    border: 1px solid #E2E2EB;
    border-radius: 2px;
    margin-bottom: 25px;
`;

export const StyledButton = styled(Button)`
    font-family: ${inter};
    font-size: 15px;
    font-weight: 600;
    color: ${white};
    float: right;
`;